import type { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileStickyCTA } from "./MobileStickyCTA";
import { useRouterState } from "@tanstack/react-router";

export function SiteShell({ children }: { children: ReactNode }) {
  const path = useRouterState({ select: (state) => state.location.pathname });
  const centered = path === "/about" || path === "/case-studies" || path === "/services" || path.startsWith("/services/") || path === "/industries" || path.startsWith("/industries/") || path.startsWith("/glossary/") || path === "/research" || path.startsWith("/research/") || /^\/(phoenix|scottsdale|mesa|chandler)-ppc-agency$/.test(path);
  return (
    <div id="top" className="flex min-h-screen flex-col">
      <Header />
      <main className={`flex-1${centered ? " centered-reading" : ""}`} style={{ paddingBottom: 0 }}>
        {children}
      </main>
      <Footer />
      <MobileStickyCTA />
      <style>{`
        @media (max-width: 767px) {
          body { padding-bottom: 64px; }
        }
      `}</style>
    </div>
  );
}
